import LoginForm from './login-form';
import RegisterContent, { SMS_KEY } from '../../register/register-content';
import Modal from '../../shared/modals/modal';
import { useNavigate } from 'react-router-dom';

export type AUTH_STATE = 'LOGIN' | 'REGISTER' | 'DONE';

export type WebinarModalPropsType = {
  showModal: boolean;
  mobile: string;
  state: AUTH_STATE;
  onSuccess: () => void;
  onClose: () => void;
};

function WebinarModal({ state, mobile, showModal, onSuccess, onClose }: WebinarModalPropsType) {
  const navigate = useNavigate();
  if (!showModal) return null;

  function getContent() {
    switch (state) {
      case 'LOGIN':
        return (
          <div className='mt-6'>
            <LoginForm mobile={mobile} onSuccess={onSuccess} />
          </div>
        );
      case 'REGISTER':
        return (
          <div className='mt-6'>
            <RegisterContent
              noLabel
              startStep={SMS_KEY}
              defaultMobile={mobile}
              onSuccess={onSuccess}
              onCancel={onClose}
            />
          </div>
        );
      case 'DONE':
        navigate('/store');
    }
  }

  return (
    <Modal showCloseButton showModal={showModal} onClose={onClose}>
      {getContent()}
    </Modal>
  );
}

export default WebinarModal;
